import TechnologyDetailPage from "@/pages/technologies/components/TechnologyDetailPage";

export default function VueTechPage() {
  return <TechnologyDetailPage slug="vue-js" />;
}